// import { mainColor } from "src/styles/mainstyle";

export const appBarStyles = {
  bgcolor: "white",
  zoom: 1.1,
  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.08)",
};
